import React from 'react';
import WaterBalanceSequential from 'views/Meteorology/Agro/WaterBalanceSequential';
import DetailedView from 'views/Meteorology/Agro/WaterBalanceSequential/DetailedView';
import Maps from 'views/Meteorology/Agro/WaterBalanceSequential/Maps';

const waterBalanceSequentialRouter = {
  path: 'water-balance-sequential',
  element: <WaterBalanceSequential />,
  children: [
    { path: '', element: <Maps /> },
    { path: 'detailed-view', element: <DetailedView /> },
  ],
};

export default waterBalanceSequentialRouter;
